import makeStyles from '@mui/styles/makeStyles';

const innerSurface =
    "linear-gradient(180deg, var(--atl-surface-solid-muted) 0%, var(--atl-surface-solid) 100%)";

export const GestioneModuliStyle = makeStyles(theme => ({
    panelActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
        flexWrap: "wrap",
    },
    addButton: {
        width: "36px !important",
        height: "36px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 34%, var(--atl-border)) !important",
        color: "var(--atl-blue) !important",
        background: "color-mix(in srgb, var(--atl-blue) 10%, var(--atl-surface-solid)) !important",
        "&:hover": {
            background: "color-mix(in srgb, var(--atl-blue) 16%, var(--atl-surface-solid)) !important",
        },
    },
    moduleList: {
        display: "grid",
        gap: theme.spacing(1),
    },
    moduleCard: {
        position: "relative",
        display: "grid",
        gridTemplateColumns: "52px minmax(0, 1fr) 96px 132px",
        gap: theme.spacing(1),
        alignItems: "center",
        minHeight: 82,
        padding: theme.spacing(1.15, 1.25),
        border: "1px solid var(--atl-border)",
        borderRadius: 18,
        color: "var(--atl-text)",
        background: innerSurface,
        boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
        overflow: "hidden",
        transition: "transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            borderColor: "color-mix(in srgb, var(--atl-blue) 36%, var(--atl-border))",
            boxShadow: "var(--atl-shadow-strong)",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "46px minmax(0, 1fr)",
            alignItems: "start",
        },
    },
    moduleAvatar: {
        display: "grid",
        placeItems: "center",
        width: 46,
        height: 46,
        borderRadius: 15,
        color: "#fff",
        background: "linear-gradient(135deg, var(--atl-blue) 0%, var(--atl-teal) 100%)",
        boxShadow: "0 10px 22px color-mix(in srgb, var(--atl-blue) 24%, transparent)",
        "& .MuiSvgIcon-root": {
            fontSize: 26,
        },
        [theme.breakpoints.down("sm")]: {
            width: 42,
            height: 42,
            borderRadius: 14,
        },
    },
    moduleCardBody: {
        minWidth: 0,
        display: "grid",
        gap: theme.spacing(0.75),
    },
    moduleCardTop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: theme.spacing(0.75),
        minWidth: 0,
        flexWrap: "wrap",
    },
    moduleIdBadge: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto",
        minHeight: 26,
        minWidth: 48,
        padding: theme.spacing(0.3, 0.75),
        borderRadius: 999,
        border: "1px solid color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border))",
        color: "var(--atl-blue)",
        background: "linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 16%, var(--atl-surface-solid)) 0%, color-mix(in srgb, var(--atl-cyan) 10%, var(--atl-surface-solid)) 100%)",
        boxShadow: "0 6px 14px color-mix(in srgb, var(--atl-blue) 10%, transparent)",
        fontSize: 12,
        fontWeight: 950,
        lineHeight: 1,
    },
    techInfoList: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(0.65),
        minWidth: 0,
    },
    techInfo: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.45),
        minHeight: 26,
        maxWidth: "100%",
        padding: theme.spacing(0.35, 0.75),
        borderRadius: 999,
        border: "1px solid var(--atl-border)",
        color: "var(--atl-text)",
        background: "var(--atl-surface-solid)",
        fontSize: 11,
        lineHeight: 1,
        "& span": {
            color: "var(--atl-text-soft)",
            fontWeight: 850,
            textTransform: "uppercase",
        },
        "& strong": {
            minWidth: 0,
            color: "var(--atl-text)",
            fontWeight: 900,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
    },
    moduleMetric: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(0.45),
        minHeight: 40,
        minWidth: 92,
        padding: theme.spacing(0.45, 1.05),
        borderRadius: 999,
        border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border))",
        background: "color-mix(in srgb, var(--atl-blue) 6%, var(--atl-surface-solid))",
        boxShadow: "0 8px 18px color-mix(in srgb, var(--atl-blue) 8%, transparent)",
        [theme.breakpoints.down("sm")]: {
            gridColumn: "1 / -1",
            justifySelf: "start",
            width: "max-content",
        },
    },
    metricValue: {
        margin: "0 !important",
        color: "var(--atl-text)",
        fontSize: "17px !important",
        fontWeight: "900 !important",
        lineHeight: "1 !important",
    },
    metricLabel: {
        margin: "0 !important",
        color: "var(--atl-text-soft)",
        fontSize: "11px !important",
        fontWeight: "850 !important",
        textTransform: "uppercase",
    },
    cardActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.65),
        justifyContent: "flex-end",
        minHeight: 40,
        [theme.breakpoints.down("sm")]: {
            gridColumn: "1 / -1",
            justifyContent: "flex-start",
        },
    },
    actionButton: {
        width: "36px !important",
        height: "36px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--module-action-color) 38%, var(--atl-border)) !important",
        color: "var(--module-action-color) !important",
        background: "color-mix(in srgb, var(--module-action-color) 10%, var(--atl-surface-solid)) !important",
        boxShadow: "0 8px 18px color-mix(in srgb, var(--module-action-color) 12%, transparent)",
        "&:hover": {
            borderColor: "color-mix(in srgb, var(--module-action-color) 58%, var(--atl-border)) !important",
            color: "#fff !important",
            background: "linear-gradient(135deg, var(--module-action-color) 0%, color-mix(in srgb, var(--module-action-color) 76%, #000) 100%) !important",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "19px !important",
        },
    },
    pagination: {
        display: "flex",
        justifyContent: "center",
        marginTop: theme.spacing(1.5),
    },
    paginationBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: theme.spacing(1.25),
        minHeight: 50,
        padding: theme.spacing(0.55, 1.75),
        border: "1px solid var(--atl-border)",
        borderRadius: 999,
        color: "var(--atl-text)",
        background: innerSurface,
        boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
    },
    paginationRows: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.75),
        minHeight: 38,
        paddingLeft: theme.spacing(0.25),
        color: "var(--atl-text-soft)",
        fontSize: 12,
        fontWeight: 850,
    },
    paginationSelect: {
        width: "78px !important",
        "&&, && .MuiFormControl-root": {
            width: "78px !important",
        },
        "&& .MuiInputBase-root, && .MuiOutlinedInput-root, && .MuiAutocomplete-inputRoot": {
            height: "38px !important",
            minHeight: "38px !important",
            borderRadius: "999px !important",
            padding: "0 30px 0 14px !important",
        },
        "&& .MuiInputBase-input, && .MuiOutlinedInput-input, && .MuiAutocomplete-input": {
            height: "38px !important",
            lineHeight: "38px !important",
            padding: "0 !important",
            textAlign: "center",
            fontSize: "14px !important",
            fontWeight: "900 !important",
        },
        "&& .MuiAutocomplete-endAdornment": {
            right: "8px !important",
            top: "50% !important",
            transform: "translateY(-50%)",
        },
    },
    paginationActions: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.45),
    },
    paginationButton: {
        width: "38px !important",
        height: "38px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 26%, var(--atl-border)) !important",
        color: "var(--atl-blue) !important",
        background: "color-mix(in srgb, var(--atl-blue) 8%, var(--atl-surface-solid)) !important",
        "&:hover": {
            borderColor: "color-mix(in srgb, var(--atl-blue) 44%, var(--atl-border)) !important",
            background: "color-mix(in srgb, var(--atl-blue) 14%, var(--atl-surface-solid)) !important",
        },
        "&.Mui-disabled": {
            opacity: "0.42 !important",
            color: "var(--atl-text-soft) !important",
            background: "var(--atl-surface-solid-muted) !important",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "20px !important",
        },
    },
    paginationRange: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 104,
        height: 38,
        minHeight: 38,
        padding: theme.spacing(0, 1.15),
        borderRadius: 999,
        color: "var(--atl-text)",
        background: "var(--atl-surface-solid)",
        border: "1px solid var(--atl-border)",
        fontSize: 12,
        fontWeight: 900,
    },
    skeletonRow: {
        height: 82,
        borderRadius: "18px !important",
        background: "var(--atl-surface-solid-muted) !important",
    },
    editHeaderActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
        flexWrap: "wrap",
    },
    moduleEditPanel: {
        "& + &": {
            marginTop: theme.spacing(1),
        },
    },
    moduleEditTop: {
        display: "grid",
        gridTemplateColumns: "minmax(280px, 1fr) minmax(320px, 0.8fr)",
        gap: theme.spacing(1.25),
        alignItems: "start",
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
    moduleEditFacts: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(0.75),
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    editFact: {
        minWidth: 0,
        minHeight: 40,
        padding: theme.spacing(0.8, 1),
        borderRadius: 16,
        border: "1px solid var(--atl-border)",
        background: innerSurface,
        "& span": {
            display: "block",
            color: "var(--atl-text-soft)",
            fontSize: 10,
            fontWeight: 900,
            lineHeight: 1,
            textTransform: "uppercase",
        },
        "& strong": {
            display: "block",
            marginTop: 4,
            color: "var(--atl-text)",
            fontSize: 13,
            fontWeight: 900,
            lineHeight: 1.1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
    },
    editLoading: {
        display: "grid",
        gap: theme.spacing(1),
    },
    previewFab: {
        position: "fixed !important",
        right: `${theme.spacing(2.25)} !important`,
        bottom: `${theme.spacing(2.25)} !important`,
        zIndex: theme.zIndex.drawer + 2,
        width: "54px !important",
        height: "54px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
        color: "#fff !important",
        background: "linear-gradient(135deg, var(--atl-blue) 0%, var(--atl-teal) 100%) !important",
        boxShadow: "0 18px 34px color-mix(in srgb, var(--atl-blue) 28%, transparent)",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 22px 42px color-mix(in srgb, var(--atl-blue) 34%, transparent)",
        },
        "&.Mui-disabled": {
            opacity: "0.46 !important",
            color: "var(--atl-text-soft) !important",
            background: "var(--atl-surface-solid-muted) !important",
            boxShadow: "none !important",
        },
    },
    searchFab: {
        bottom: `calc(${theme.spacing(2.25)} + 66px) !important`,
        background: "linear-gradient(135deg, var(--atl-cyan) 0%, var(--atl-blue) 100%) !important",
    },
    quickSearchDialog: {
        display: "grid",
        gap: theme.spacing(1),
        minWidth: 0,
        paddingTop: theme.spacing(0.25),
    },
    quickSearchSelect: {
        width: "100% !important",
        "&&, && .MuiFormControl-root": {
            width: "100% !important",
        },
    },
    rowsToolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexWrap: "wrap",
        gap: theme.spacing(0.75),
        maxWidth: "100%",
    },
    rowJumpSelect: {
        width: "680px !important",
        maxWidth: "100%",
        flex: "1 1 680px",
        "&&, && .MuiFormControl-root": {
            width: "680px !important",
            maxWidth: "100%",
        },
        "&& .MuiInputBase-root": {
            minHeight: "36px !important",
            borderRadius: "999px !important",
        },
        "&& .MuiInputBase-input, && .MuiOutlinedInput-input, && .MuiAutocomplete-input": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        [theme.breakpoints.down("sm")]: {
            flex: "1 1 100%",
            width: "100% !important",
            "&&, && .MuiFormControl-root": {
                width: "100% !important",
            },
        },
    },
    rowsModeToggle: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(0.5),
        minHeight: 36,
        padding: theme.spacing(0.15, 0.35, 0.15, 1),
        borderRadius: 999,
        border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border))",
        color: "var(--atl-text)",
        background: "color-mix(in srgb, var(--atl-blue) 7%, var(--atl-surface-solid))",
        cursor: "pointer",
        whiteSpace: "nowrap",
        "& .MuiSwitch-root": {
            margin: 0,
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: "var(--atl-blue)",
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "var(--atl-blue)",
            opacity: 0.42,
        },
    },
    rowsModeLabel: {
        color: "var(--atl-text)",
        fontSize: 12,
        fontWeight: 900,
        lineHeight: 1,
    },
    rowJumpOption: {
        display: "grid",
        gap: theme.spacing(0.35),
        minWidth: 0,
        width: "100%",
    },
    rowJumpOptionHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        minWidth: 0,
    },
    rowJumpOptionTitle: {
        color: "var(--atl-text)",
        fontSize: "13px !important",
        fontWeight: "900 !important",
        lineHeight: "1.15 !important",
    },
    rowJumpOptionMeta: {
        flex: "0 0 auto",
        color: "var(--atl-text-soft)",
        fontSize: "11px !important",
        fontWeight: "850 !important",
        lineHeight: "1.15 !important",
        textTransform: "uppercase",
    },
    rowJumpOptionFields: {
        color: "var(--atl-text-soft)",
        fontSize: "12px !important",
        fontWeight: "750 !important",
        lineHeight: "1.25 !important",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    editRowsStack: {
        display: "grid",
        gap: theme.spacing(1),
    },
    editRowCard: {
        scrollMarginTop: 112,
        border: "1px solid var(--atl-border)",
        borderRadius: 18,
        background: innerSurface,
        boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
        overflow: "hidden",
    },
    editRowHeader: {
        display: "grid",
        gridTemplateColumns: "minmax(132px, 220px) minmax(0, 1fr) auto",
        alignItems: "center",
        gap: theme.spacing(1.35),
        minHeight: 64,
        padding: theme.spacing(0.9, 1.1),
        borderBottom: "1px solid var(--atl-border)",
        [theme.breakpoints.down("lg")]: {
            gridTemplateColumns: "minmax(132px, 1fr) auto",
        },
        [theme.breakpoints.down("sm")]: {
            alignItems: "stretch",
            gridTemplateColumns: "1fr",
        },
    },
    editRowToggle: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.8),
        minWidth: 0,
        padding: 0,
        border: 0,
        color: "var(--atl-text)",
        background: "transparent",
        cursor: "pointer",
        textAlign: "left",
    },
    editRowIcon: {
        display: "grid",
        placeItems: "center",
        width: 36,
        height: 36,
        flex: "0 0 auto",
        borderRadius: 999,
        color: "var(--atl-blue)",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 26%, var(--atl-border))",
        background: "color-mix(in srgb, var(--atl-blue) 8%, var(--atl-surface-solid))",
        "& .MuiSvgIcon-root": {
            fontSize: 21,
        },
    },
    editRowTitle: {
        display: "block",
        color: "var(--atl-text)",
        fontSize: "15px !important",
        fontWeight: "900 !important",
        lineHeight: "1.1 !important",
    },
    editRowMeta: {
        display: "block",
        marginTop: 3,
        color: "var(--atl-text-soft)",
        fontSize: "12px !important",
        fontWeight: "800 !important",
        lineHeight: "1.1 !important",
    },
    editRowActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        gap: theme.spacing(1.1),
        minWidth: 0,
        width: "100%",
        padding: theme.spacing(0, 1),
        [theme.breakpoints.down("lg")]: {
            gridColumn: "1 / -1",
            gridRow: 2,
            justifyContent: "center",
            padding: theme.spacing(0.5, 0, 0),
        },
    },
    rowActionGroup: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        gap: theme.spacing(0.45),
        minHeight: 36,
        minWidth: 0,
    },
    rowActionGroupLabel: {
        flex: "0 0 auto",
        color: "var(--atl-text-soft)",
        fontSize: 10,
        fontWeight: 900,
        lineHeight: 1,
        textTransform: "uppercase",
    },
    rowActionButton: {
        height: "34px !important",
        minWidth: "0 !important",
        padding: "0 10px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 26%, var(--atl-border)) !important",
        color: "var(--atl-blue) !important",
        background: "color-mix(in srgb, var(--atl-blue) 7%, var(--atl-surface-solid)) !important",
        fontSize: "11px !important",
        fontWeight: "900 !important",
        letterSpacing: "0 !important",
        lineHeight: "1 !important",
        textTransform: "none !important",
        whiteSpace: "nowrap",
        "&:hover": {
            background: "color-mix(in srgb, var(--atl-blue) 13%, var(--atl-surface-solid)) !important",
        },
        "&.Mui-disabled": {
            opacity: "0.42 !important",
            color: "var(--atl-text-soft) !important",
            background: "var(--atl-surface-solid-muted) !important",
        },
        "& .MuiButton-startIcon": {
            marginLeft: "0 !important",
            marginRight: "4px !important",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "17px !important",
        },
    },
    rowDeleteAction: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        minWidth: 36,
        [theme.breakpoints.down("lg")]: {
            gridColumn: 2,
            gridRow: 1,
        },
        [theme.breakpoints.down("sm")]: {
            gridColumn: "1 / -1",
            gridRow: "auto",
            justifyContent: "flex-end",
        },
    },
    editIconButton: {
        width: "34px !important",
        height: "34px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-blue) 26%, var(--atl-border)) !important",
        color: "var(--atl-blue) !important",
        background: "color-mix(in srgb, var(--atl-blue) 8%, var(--atl-surface-solid)) !important",
        "&:hover": {
            background: "color-mix(in srgb, var(--atl-blue) 14%, var(--atl-surface-solid)) !important",
        },
        "&.Mui-disabled": {
            opacity: "0.42 !important",
            color: "var(--atl-text-soft) !important",
            background: "var(--atl-surface-solid-muted) !important",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "19px !important",
        },
    },
    editIconButtonDanger: {
        width: "34px !important",
        height: "34px !important",
        borderRadius: "999px !important",
        border: "1px solid color-mix(in srgb, var(--atl-red) 34%, var(--atl-border)) !important",
        color: "var(--atl-red) !important",
        background: "color-mix(in srgb, var(--atl-red) 8%, var(--atl-surface-solid)) !important",
        "&:hover": {
            background: "color-mix(in srgb, var(--atl-red) 14%, var(--atl-surface-solid)) !important",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "19px !important",
        },
    },
    editFieldsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(240px, 1fr))",
        gap: theme.spacing(1),
        padding: theme.spacing(1),
        [theme.breakpoints.down("xl")]: {
            gridTemplateColumns: "repeat(3, minmax(240px, 1fr))",
        },
        [theme.breakpoints.down("lg")]: {
            gridTemplateColumns: "repeat(2, minmax(240px, 1fr))",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    editFieldCard: {
        display: "grid",
        gap: theme.spacing(1),
        minWidth: 0,
        padding: theme.spacing(1),
        borderRadius: 16,
        border: "1px solid var(--atl-border)",
        background: "var(--atl-surface-solid)",
        boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
    },
    editFieldHeader: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: theme.spacing(1),
    },
    editFieldTitle: {
        color: "var(--atl-text)",
        fontSize: "14px !important",
        fontWeight: "900 !important",
        lineHeight: "1.15 !important",
    },
    editFieldMeta: {
        marginTop: "2px !important",
        color: "var(--atl-text-soft)",
        fontFamily: "monospace",
        fontSize: "11px !important",
        fontWeight: "800 !important",
        lineHeight: "1.2 !important",
        wordBreak: "break-all",
    },
    editFieldActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(0.35),
        flex: "0 0 auto",
    },
    editFieldGrid: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: theme.spacing(0.85),
        minWidth: 0,
        "& > *": {
            minWidth: 0,
        },
        "& [data-solid-text-field='true'], & [data-solid-autocomplete='true']": {
            width: "100% !important",
            minWidth: "0 !important",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    optionsEditor: {
        display: "grid",
        gap: theme.spacing(0.75),
        padding: theme.spacing(0.85),
        borderRadius: 14,
        border: "1px solid var(--atl-border)",
        background: innerSurface,
    },
    optionInputRow: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: theme.spacing(0.75),
        alignItems: "start",
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    optionChips: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(0.5),
    },
    optionChip: {
        border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border)) !important",
        color: "var(--atl-text) !important",
        background: "color-mix(in srgb, var(--atl-blue) 8%, var(--atl-surface-solid)) !important",
        fontWeight: "800 !important",
    },
    actionArea: {
        height: 120,
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 20,
        paddingBottom: 20
    },
    cardContent: {
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    tooltip:{
        marginTop: -5,
    },
}));
